var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "default-item" },
      _vm._l(_vm.brokersList, function (broker) {
        return _c(
          "div",
          {
            key: broker._id,
            staticClass:
              "card-item shadowless has-text-centered default-item-info med-size-text my-3",
          },
          [
            _c("div", { staticClass: "items-alignment" }, [
              _c("span", { staticClass: "default-item-name content-title" }, [
                _vm._v(
                  " " +
                    _vm._s(broker.name || _vm.$t("not-avaliable-data")) +
                    " "
                ),
              ]),
              broker.brokerSource.origin !== "commercial-manager"
                ? _c(
                    "span",
                    { staticClass: "prospect-broker-tag creditu-tag" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            broker.brokerSource.name ||
                              _vm.$t("simulator-front-end")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "b-tooltip",
              { attrs: { label: _vm.$t("idNumber"), position: "is-left" } },
              [
                _c("span", { staticClass: "default-item-idnumber" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-address-card has-text-primary",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(broker.idNumber || _vm.$t("not-avaliable-data")) +
                      " "
                  ),
                ]),
              ]
            ),
            _c(
              "b-tooltip",
              { attrs: { label: _vm.$t("status"), position: "is-left" } },
              [
                _c("span", { staticClass: "default-item-status" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-user-tie has-text-primary",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        (broker.status && broker.status === "ACTIVE"
                          ? _vm.$t("active")
                          : _vm.$t("inactive")) || _vm.$t("not-avaliable-data")
                      ) +
                      " "
                  ),
                ]),
              ]
            ),
            _c("span", { staticClass: "default-item-prospects" }, [
              _c("i", { staticClass: "fa-solid fa-users has-text-primary" }),
              _vm._v(
                " Leads: " +
                  _vm._s(
                    broker.prospectsList ? broker.prospectsList.length : 0
                  ) +
                  " "
              ),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "button manage-button is-button-secondary is-rounded is-fullwidth-mobile",
                attrs: { id: `broker-${broker._id}` },
                on: {
                  click: function ($event) {
                    return _vm.goToSingleBrokerView(broker._id)
                  },
                },
              },
              [
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.$t("button-manage")) + " "),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }